type InfoIconProps = {
  className?: string;
};

export default function InfoIcon({ className }: InfoIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Info</title>
      <path
        d="M10 2.21094C14.2949 2.21094 17.7891 5.70513 17.7891 10C17.7891 14.2949 14.2949 17.7891 10 17.7891C5.70513 17.7891 2.21094 14.2949 2.21094 10C2.21094 5.70513 5.70513 2.21094 10 2.21094ZM8.90625 8.25781C8.73427 8.25781 8.56887 8.32566 8.44727 8.44727C8.32566 8.56887 8.25781 8.73427 8.25781 8.90625C8.25781 9.07823 8.32566 9.24363 8.44727 9.36523C8.56887 9.48684 8.73427 9.55469 8.90625 9.55469H9.50781V12.9453H8.4375C8.26552 12.9453 8.10012 13.0132 7.97852 13.1348C7.85691 13.2564 7.78906 13.4218 7.78906 13.5938C7.78906 13.7657 7.85691 13.9311 7.97852 14.0527C8.10012 14.1743 8.26552 14.2422 8.4375 14.2422H11.875C12.047 14.2422 12.2124 14.1743 12.334 14.0527C12.4556 13.9311 12.5234 13.7657 12.5234 13.5938C12.5234 13.4218 12.4556 13.2564 12.334 13.1348C12.2124 13.0132 12.047 12.9453 11.875 12.9453H10.8047V8.90625C10.8047 8.73427 10.7368 8.56887 10.6152 8.44727C10.4936 8.32566 10.3282 8.25781 10.1562 8.25781H8.90625ZM10 5.36719C9.72442 5.36719 9.46049 5.47701 9.26562 5.67188C9.07076 5.86674 8.96094 6.13067 8.96094 6.40625C8.96094 6.61167 9.02167 6.81257 9.13574 6.9834C9.24992 7.15427 9.41268 7.28757 9.60254 7.36621C9.79236 7.44481 10.0016 7.46586 10.2031 7.42578C10.4046 7.38565 10.5891 7.28587 10.7344 7.14062C10.8796 6.99539 10.9794 6.81081 11.0195 6.60938C11.0596 6.40787 11.0386 6.19861 10.96 6.00879C10.8813 5.81893 10.748 5.65617 10.5771 5.54199C10.4063 5.42792 10.2054 5.36719 10 5.36719Z"
        fill="#C41719"
        stroke="#444444"
        strokeWidth="0.046875"
      />
    </svg>
  );
}
